module.exports = __webpack_public_path__ + "img/menu.4584a2c5.svg";